// react
import { useMemo } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import DeleteIcon from '@mui/icons-material/Delete';

// material ui
import { Box, IconButton, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import { DateTime } from 'luxon';

const UtilityProviderCoefficientsDatagrid = ({
  coefficients,
  onDeleteCoefficient,
}) => {
  const { t } = useTranslation('portfolio-analysis');

  const columns = useMemo(
    () => [
      {
        field: 'co2e_coefficient_per_unit',
        headerName: t('utilityProviderDetailPage.datagrid.columns.coefficient'),
        flex: 1,
        minWidth: 150,
        valueFormatter: (value) => {
          return value ? value : '-';
        },
      },
      {
        field: 'start_time',
        headerName: t('utilityProviderDetailPage.datagrid.columns.startTime'),
        flex: 1,
        minWidth: 180,
        valueFormatter: (value) => {
          const dt = DateTime.fromISO(value);

          if (dt.isValid) {
            return dt.toLocaleString(DateTime.DATE_SHORT);
          }
          return value ? value : '-';
        },
      },
      {
        field: 'last_updated',
        headerName: t('utilityProviderDetailPage.datagrid.columns.lastUpdated'),
        flex: 1,
        minWidth: 180,
        valueFormatter: (value) => {
          const dt = DateTime.fromISO(value);

          if (dt.isValid) {
            return dt.toLocaleString(DateTime.DATETIME_SHORT);
          }
          return value ? value : '-';
        },
      },
      {
        field: 'actions',
        headerName: t('utilityProviderDetailPage.datagrid.columns.actions'),
        width: 100,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Tooltip
            title={t('utilityProviderDetailPage.datagrid.deleteCoefficient')}
          >
            <IconButton
              size="small"
              color="error"
              onClick={() => onDeleteCoefficient(params.row)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ),
      },
    ],
    [t, onDeleteCoefficient],
  );

  // Create unique IDs for rows since coefficients don't have IDs
  const rowsWithIds = useMemo(() => {
    return coefficients.map((coef, index) => ({
      ...coef,
      id: `${coef.start_time}-${coef.end_time}-${index}`,
    }));
  }, [coefficients]);

  return (
    <Box sx={{ height: 500, width: '100%' }}>
      <DataGrid
        rows={rowsWithIds}
        columns={columns}
        pageSizeOptions={[10, 25, 50, 100]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 25, page: 0 },
          },
          sorting: {
            sortModel: [{ field: 'start_time', sort: 'desc' }],
          },
        }}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default UtilityProviderCoefficientsDatagrid;
